import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IncidentIcon = React.forwardRef((props: SvgIconProps, ref: any) => (
  <SvgIcon width="18" height="16" viewBox="0 0 18 16" fill="none" {...props} ref={ref}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00303 15.8109C0.45637 15.8109 -0.504965 14.1304 0.278975 12.7972L7.22359 0.986268C7.99681 -0.328775 9.89848 -0.328777 10.6717 0.986267L17.6163 12.7972C18.4003 14.1304 17.4389 15.8109 15.8923 15.8109H2.00303ZM10.1064 9.6346H7.78626V5.77443H10.1064V9.6346ZM10.1064 12.7227H7.78626V11.1787H10.1064V12.7227Z"
      fill="#70777A"
    />
  </SvgIcon>
));
